var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 21L0 12.3955L2.791 9.53658L8.947 15.3878L21.157 3L24 5.80609L9 21Z","fill":"currentColor"}));
}

Check.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Check;

Check.default = Check;
